import React, { useState, useEffect, useRef } from "react";
import { get, post } from "../../services/api";

const StudentInterview = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const centerId = localStorage.getItem("centerId");
  const roleId = localStorage.getItem("roleId");

  const [classesData, setClassesData] = useState([]);
  const [registrationsData, setRegistrationsData] = useState([]);

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClassesByCenterId();
  }, []);

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRegistrationsData(response);
    } catch (error) {
      console.error("Error fetching Centers:", error);
    }
  };

  useEffect(() => {
    getRegistrationsList();
  }, [organizationId, centerId]);

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Interview Status</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {registrationsData.map((item) => {
              const selectedClass = classesData.find(
                (classItem) => classItem.id === item.centerClassId
              );

              return (
                <div className="col-md-4" key={item.id}>
                  <div className="card h-100">
                    <div className="card-header fs-8 p-3 py-2 bg-light fw-bold">
                      {`${item.firstName} ${item.lastName}`}
                    </div>
                    <div className="fs-9 p-3">
                      <div>
                        <strong>Class:</strong> {selectedClass?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Interview Date:</strong>{" "}
                        {item.interviewDate?.split("T")[0] || "N/A"}
                      </div>
                      <div>
                        <strong>Interview Taken:</strong>{" "}
                        {item.isInterviewTaken ? "Yes" : "No" || "N/A"}
                      </div>
                      <div>
                        <strong>Interview Remarks:</strong>{" "}
                        {item.interviewRemarks || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentInterview;
